<template>
  <div class="tag-container">
    <!-- 查询控件卡片 -->
    <el-card class="filter-card">
      <div class="filter-container">
        <!-- 左侧查询表单 -->
        <div class="left-section">
          <el-form :inline="true" :model="searchForm" class="filter-form" size="small">
            <div class="form-content">
              <!-- 标签名称 -->
              <el-form-item>
                <el-input
                  v-model="searchForm.tag_name"
                  placeholder="标签名称"
                  clearable
                  @keyup.enter.native="handleSearch"
                  style="width: 180px">
                </el-input>
              </el-form-item>
              
              <!-- 时间范围 -->
              <el-form-item>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                  style="width: 260px">
                </el-date-picker>
              </el-form-item>
              
              <el-form-item class="filter-buttons">
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleSearch">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 右侧数据展示 -->
        <div class="right-section">
          <!-- 全部标签按钮 -->
          <el-button 
            :type="showAllTags ? 'warning' : 'primary'" 
            size="small" 
            @click="handleAllTags">
            {{ showAllTags ? '不显示全部标签' : '显示全部标签' }}
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- 数据表格卡片 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="displayTagList"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#f2f3f5',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px',
          height: '52px',
          padding: '0'
        }"
        @sort-change="handleSortChange">
        
        <!-- 序号列 -->
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column
          prop="tag_name"
          label="标签名称"
          sortable="custom"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="correct_rate"
          label="正确率"
          sortable="custom"
          min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ scope.row.correct_rate.toFixed(2) }}%</span>
              <el-progress 
                :percentage="scope.row.correct_rate" 
                :show-text="false"
                :stroke-width="5"
                color="#13C2C2">
              </el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="question_score_avg"
          label="平均得分"
          sortable="custom"
          min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ scope.row.question_score_avg.toFixed(2) }}</span>
              <el-progress 
                :percentage="scope.row.question_score_avg" 
                :show-text="false"
                :stroke-width="5"
                color="#409EFF">
              </el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="question_score_fix_avg"
          label="平均订正分"
          sortable="custom"
          min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ scope.row.question_score_fix_avg.toFixed(2) }}</span>
              <el-progress 
                :percentage="scope.row.question_score_fix_avg" 
                :show-text="false"
                :stroke-width="5"
                color="#67C23A">
              </el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fix_rate"
          label="订正率"
          sortable="custom"
          min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ scope.row.fix_rate.toFixed(2) }}%</span>
              <el-progress 
                :percentage="scope.row.fix_rate" 
                :show-text="false"
                :stroke-width="5"
                color="#E6A23C">
              </el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="avg_difficulty"
          label="平均难度"
          sortable="custom"
          min-width="80"
          align="center">
          <template slot="header" slot-scope="scope">
            <span>平均难度</span>
            <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
              <div slot="content" class="difficulty-tooltip-content">
                <div class="difficulty-levels">
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #F56C6C;"></span>
                    <span class="level-range">00.00 ~ 14.29%:</span>
                    <span class="level-name">红题（很简单）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #E6A23C;"></span>
                    <span class="level-range">14.29 ~ 28.58%:</span>
                    <span class="level-name">橙题（简单）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #F7BA2A;"></span>
                    <span class="level-range">28.58 - 42.87%:</span>
                    <span class="level-name">黄题（较易）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #67C23A;"></span>
                    <span class="level-range">42.87 ~ 57.15%:</span>
                    <span class="level-name">绿题（中等）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #409EFF;"></span>
                    <span class="level-range">57.15 ~ 71.44%:</span>
                    <span class="level-name">蓝题（较难）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #8E44AD;"></span>
                    <span class="level-range">71.44 ~ 85.72%:</span>
                    <span class="level-name">紫题（很难）</span>
                  </div>
                  <div class="difficulty-level">
                    <span class="level-color" style="background-color: #2C3E50;"></span>
                    <span class="level-range">85.72 ~ 100%:</span>
                    <span class="level-name">黑题（极难）</span>
                  </div>
                </div>
              </div>
              <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-tag
              :style="{ 
                backgroundColor: getDifficultyColorByPercentage(scope.row.avg_difficulty),
                borderColor: getDifficultyColorByPercentage(scope.row.avg_difficulty),
                color: 'white',
                height: '28px',
                lineHeight: '26px'
              }"
              :title="getDifficultyLevelByPercentage(scope.row.avg_difficulty)"
              size="small">
              <span style="font-weight: bold">{{ scope.row.avg_difficulty.toFixed(2) }}%</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="question_nums"
          label="题目数"
          sortable="custom"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="pending_questions"
          label="未订正数"
          sortable="custom"
          min-width="80">
          <template slot-scope="scope">
            <el-tag 
              :type="scope.row.pending_questions > 0 ? 'danger' : 'success'" 
              size="small">
              {{ scope.row.pending_questions }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80"
          align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleExpand(scope.row)">
              展开
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 版权信息卡片 -->
    <el-card class="copyright-card">
      <div class="copyright-content">
        <span>Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1</span>
      </div>
    </el-card>
    
    <!-- 抽屉组件 -->
    <el-drawer
      :visible.sync="drawerVisible"
      :with-header="false"
      size="75%"
      :append-to-body="false"
      :modal="false"
      :before-close="handleDrawerClose"
      custom-class="tag-drawer">
      <div class="drawer-container">
        <div class="drawer-header">
          <h3>{{ currentTag ? currentTag.tag_name : '' }} - 关联题目</h3>
          <el-button icon="el-icon-close" circle @click="drawerVisible = false"></el-button>
        </div>
        
        <el-table
          v-loading="questionLoading"
          :data="questionList"
          stripe
          style="width: 100%"
          :header-cell-style="{
            background: '#f2f3f5',
            color: '#606266',
            fontWeight: '600',
            fontSize: '14px',
            height: '52px',
            padding: '0'
          }"
          :cell-style="getCellStyle"
          @sort-change="handleQuestionSortChange">
          <el-table-column
            prop="question_name"
            label="题目名称"
            min-width="180"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip 
                :content="scope.row.question_name" 
                placement="top" 
                :open-delay="300"
                :disabled="!scope.row.question_name || scope.row.question_name.length < 15">
                <div class="text-ellipsis">
                  <a v-if="scope.row.question_url" :href="scope.row.question_url" target="_blank" class="link-text">{{ scope.row.question_name }}</a>
                  <span v-else>{{ scope.row.question_name }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="game_name"
            label="赛事名称"
            min-width="200"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip 
                :content="scope.row.game_name" 
                placement="top" 
                :open-delay="300"
                :disabled="!scope.row.game_name || scope.row.game_name.length < 20">
                <div class="text-ellipsis">
                  <a v-if="scope.row.game_url" :href="scope.row.game_url" target="_blank" class="link-text">{{ scope.row.game_name }}</a>
                  <span v-else>{{ scope.row.game_name }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="question_seq"
            label="题号"
            width="75"
            sortable="custom">
          </el-table-column>
          <el-table-column
            prop="question_score"
            label="分数"
            width="100"
            align="center"
            sortable="custom">
            <template slot-scope="scope">
              <div class="score-cell">
                <i v-if="scope.row.question_score === 100" 
                   class="el-icon-medal-1" 
                   style="margin-right: 4px;">
                </i>
                <span :class="{
                  'score-perfect': scope.row.question_score === 100,
                  'score-warning': scope.row.question_score < 100
                }">
                  {{ scope.row.question_score }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="question_score_fix"
            label="订正分数"
            width="100"
            align="center"
            sortable="custom">
            <template slot-scope="scope">
              <div class="score-cell">
                <i v-if="scope.row.question_score_fix === 100" 
                   class="el-icon-medal-1" 
                   :style="{ color: getScoreColor(scope.row.question_score_fix), marginRight: '4px' }"></i>
                <span :style="{ color: getScoreColor(scope.row.question_score_fix), fontWeight: 'bold' }">
                  {{ scope.row.question_score_fix }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="question_level"
            label="题目难度"
            width="100"
            align="center"
            sortable="custom">
            <template slot-scope="scope">
              <el-tag
                :style="{ 
                  backgroundColor: getDifficultyColor(scope.row.question_level || '未定义'),
                  borderColor: getDifficultyColor(scope.row.question_level || '未定义'),
                  color: 'white',
                  height: '28px',
                  lineHeight: '26px'
                }"
                size="small">
                {{ scope.row.question_level || '未定义' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="errors"
            label="错误类型"
            min-width="160"
            align="left"
            class-name="error-type-column">
            <template slot="header" slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <span>错误类型</span>
                <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
                  <div slot="content" class="difficulty-tooltip-content">
                    <div class="difficulty-description">
                      <p><strong>1. 算法未掌握</strong>：未掌握核心知识点、算法原理或其适用性；</p>
                      <ul>
                        <li>【学透】深入理解定义、原理、推导、复杂度</li>
                        <li>【对比】区分相似概念，明确应用场景</li>
                        <li>【复习】定期回顾基础知识</li>
                      </ul>
                      <p><strong>2. 思路/逻辑偏差</strong>：思路框架或解题逻辑有缺陷，无法构建正确解题路径；</p>
                      <ul>
                        <li>【拆解】将问题分解，逐个击破</li>
                        <li>【模拟】用小数据手动演算，验证思路</li>
                        <li>【学习】学习他人优秀解法，寻找更优思路</li>
                      </ul>
                      <p><strong>3. 实现/细节错误</strong>：思路正确，但代码细节处理不当，导致程序出错；</p>
                      <ul>
                        <li>【细抠】关注边界、初始化、数据类型、语句逻辑</li>
                        <li>【调试】熟练使用调试器，定位问题</li>
                        <li>【规范】养成良好的编码习惯</li>
                      </ul>
                      <p><strong>4. 效率/复杂度问题</strong>：算法或实现效率低，导致超时 (TLE) 或超内存 (MLE)；</p>
                      <ul>
                        <li>【估算】优先评估算法时间/空间复杂度</li>
                        <li>【优化】学习常用优化技巧（如剪枝、数据结构）</li>
                        <li>【卡点】针对性练习时间/空间敏感题</li>
                      </ul>
                      <p><strong>5. 边界/特殊情况遗漏</strong>：未考虑题目中的特殊数据、极端情况或边界条件；</p>
                      <ul>
                        <li>【预判】思考各种可能的小数据、负数、空集、全同等情况</li>
                        <li>【测试】编写专门测试边界的用例</li>
                        <li>【总结】建立边界条件检查清单</li>
                      </ul>
                      <p><strong>6. 题意理解偏差</strong>：对题目描述、要求、输入输出等理解有误；</p>
                      <ul>
                        <li>【精读】慢读、细读，划出关键词</li>
                        <li>【明确】确认输入输出格式、数据范围、约束条件</li>
                        <li>【举例】用自己的话复述题目</li>
                      </ul>
                      <p><strong>7. 工具/环境问题</strong>：编程语言特性、编译器、IDE、提交系统等非算法本身的细节问题；</p>
                      <ul>
                        <li>【熟悉】了解常用语言特性、库函数用法</li>
                        <li>【检查】留意编译警告，熟悉评测环境</li>
                        <li>【记录】记录常见坑点</li>
                      </ul>
                      <p><strong>8. 心理性错误</strong>：受情绪、心态、比赛压力等因素影响导致的技术失误；</p>
                      <ul>
                        <li>【训练】模拟赛中培养抗压能力</li>
                        <li>【调整】保持积极心态，学会自我鼓励</li>
                        <li>【暂停】遇到困难时，短暂休息，深呼吸</li>
                      </ul>
                      <p><strong>9. 其他/未分类错误</strong>：暂时难以明确归类，或属特定情况的错误；</p>
                      <ul>
                        <li>【分析】尝试将其归入现有分类</li>
                        <li>【记录】暂存，等待进一步研究或求助</li>
                      </ul>
                    </div>
                  </div>
                  <i class="el-icon-question" style="cursor: pointer; margin-left: 6px; font-size: 14px; color: #606266;"></i>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="{ row }">
              <template v-if="Number(row.question_score) === 100">
                <span style="color:#909399;">-</span>
              </template>
              <template v-else-if="expandedDrawerErrors[row.question_code]">
                <!-- 展开状态：显示所有 -->
                <el-tag
                  v-for="err in normalizeErrors(row.errors)"
                  :key="(err.error_code || err.error_name) + '-err'"
                  :style="getErrorOutlineStyle(err.error_code || err.error_name)"
                  class="error-outline-tag"
                  style="margin-right: 4px; margin-bottom: 4px; height: 28px; line-height: 26px;">
                  <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ err.error_name || err }}
                </el-tag>
                <el-button
                  v-if="normalizeErrors(row.errors).length > 1"
                  type="text"
                  class="error-expand-btn"
                  @click="toggleDrawerExpandErrors(row.question_code)">
                  收起
                </el-button>
              </template>
              <template v-else>
                <!-- 收起状态：只显示第一个 -->
                <el-tag
                  v-if="normalizeErrors(row.errors).length > 0"
                  :style="getErrorOutlineStyle(normalizeErrors(row.errors)[0].error_code || normalizeErrors(row.errors)[0].error_name)"
                  class="error-outline-tag"
                  style="margin-right: 4px; height: 28px; line-height: 26px;">
                  <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ normalizeErrors(row.errors)[0].error_name || normalizeErrors(row.errors)[0] }}
                </el-tag>
                <el-button
                  v-if="normalizeErrors(row.errors).length > 1"
                  type="text"
                  class="error-expand-btn"
                  @click="toggleDrawerExpandErrors(row.question_code)">
                  +{{ normalizeErrors(row.errors).length - 1 }}
                </el-button>
              </template>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="180"
            align="center"
            class-name="operation-column">
            <template slot="default" slot-scope="scope">
              <div class="operation-buttons">
                <el-tooltip content="编辑" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button edit-button"
                    @click="handleEdit(scope.row)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip content="订正" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.question_score_fix === 100 ? 'disabled-button' : 'fix-button'"
                    :disabled="scope.row.question_score_fix === 100"
                    @click="handleFix(scope.row)">
                    <i class="el-icon-check"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip content="复盘" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="!scope.row.has_replay ? 'disabled-button' : 'replay-button'"
                    :disabled="!scope.row.has_replay"
                    @click="openReplay(scope.row)">
                    <i class="el-icon-video-camera"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip :content="scope.row.is_collect ? '取消收藏' : '收藏'" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.is_collect ? 'collect-active-button' : 'collect-button'"
                    @click="handleCollect(scope.row)">
                    <i :class="{'el-icon-star-off': !scope.row.is_collect, 'el-icon-star-on': scope.row.is_collect}">
                    </i>
                  </el-button>
                </el-tooltip>

                <el-tooltip :content="scope.row.is_pending ? '取消挂起' : '挂起'" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.is_pending ? 'pending-active-button' : 'pending-button'"
                    @click="handlePending(scope.row)">
                    <i class="el-icon-video-pause">
                    </i>
                  </el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 抽屉分页 -->
        <div class="drawer-pagination-container">
          <el-pagination
            background
            @size-change="handleQuestionSizeChange"
            @current-change="handleQuestionCurrentChange"
            :current-page.sync="questionCurrentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="questionPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="questionTotal">
          </el-pagination>
        </div>
      </div>
    </el-drawer>
    
    <!-- 复盘弹窗 -->
    <el-dialog
      :title="replayQuestionTitle ? `${replayQuestionTitle} - 复盘内容` : '复盘内容'"
      :visible.sync="replayDialogVisible"
      width="700px"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
      custom-class="tag-replay-dialog"
      @close="replayDialogVisible = false">
      <div v-loading="replayLoading">
        <markdown-viewer v-if="replayContent" :content="replayContent" />
        <div v-else style="color:#909399;">暂无复盘内容</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="replayDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 题目编辑对话框 -->
    <question-dialog
      :visible.sync="editDialogVisible"
      :question="currentQuestion"
      :is-edit="true"
      :game-code="currentQuestion ? currentQuestion.game_code : ''"
      :append-to-body="true"
      :modal-append-to-body="true"
      custom-class="tag-edit-dialog"
      @success="handleSuccess"
      @cancel="editDialogVisible = false">
    </question-dialog>
  </div>
</template>

<script>
import { getTagsStatistics, getTagQuestions } from '@/api/tag'
import { getQuestionReplay, updateQuestionCollect, updateQuestionPending } from '@/api/question'
import { getErrorOutlineStyle } from '@/constants/errorTypes'
import MarkdownViewer from '@/components/MarkdownViewer.vue'
import QuestionDialog from '@/views/game/components/QuestionDialog.vue'
import request from '@/utils/request'

export default {
  name: 'Tag',
  components: { MarkdownViewer, QuestionDialog },
  data() {
    return {
      loading: false,
      questionLoading: false,
      tagList: [],
      displayTagList: [], // 用于显示的分页数据
      questionList: [],
      allQuestionList: [], // 存储所有题目数据
      searchForm: {
        tag_name: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      drawerVisible: false,
      expandedTag: null,
      currentTag: null,
      sortProp: 'pending_questions',
      sortOrder: 'descending',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      showAllTags: false,
      // 新增抽屉分页相关数据
      questionCurrentPage: 1,
      questionPageSize: 20,
      questionTotal: 0,
      questionSortProp: '',
      questionSortOrder: '',
      // 复盘相关
      replayDialogVisible: false,
      replayLoading: false,
      replayContent: '',
      replayQuestionTitle: '',
      // 编辑对话框相关
      editDialogVisible: false,
      currentQuestion: null,
      
      // 抽屉内的展开状态
      expandedDrawerErrors: {}  // 记录抽屉内错误类型的展开状态
    }
  },
  created() {
    this.fetchTagList()
  },
  mounted() {
    this.setupDialogZIndex()
  },
  methods: {
    // 自定义单元格样式
    getCellStyle({ row, column, rowIndex, columnIndex }) {
      // 如果是错误类型列，移除背景色
      if (column.property === 'errors') {
        return {
          backgroundColor: 'transparent'
        }
      }
      return {}
    },
    async openReplay(row) {
      if (!row || !row.question_code) return
      this.replayDialogVisible = true
      this.replayLoading = true
      this.replayContent = ''
      this.replayQuestionTitle = row.question_name || ''
      try {
        const resp = await getQuestionReplay(row.question_code)
        if (resp && resp.code === 200) {
          this.replayContent = resp.data || ''
        } else {
          this.$message.error('获取复盘失败')
          this.replayDialogVisible = false
        }
      } catch (e) {
        this.$message.error('获取复盘失败')
        this.replayDialogVisible = false
      } finally {
        this.replayLoading = false
      }
    },
    // 获取标签列表
    async fetchTagList() {
      this.loading = true
      try {
        const response = await getTagsStatistics({
          tag_name: this.searchForm.tag_name,
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time,
          show_all: this.showAllTags // 根据状态决定是否显示全部标签
        })
        
        if (response && response.code === 200 && response.data) {
          this.tagList = response.data || []
          this.total = this.tagList.length
          this.updateDisplayData()
        } else {
          this.tagList = []
          this.displayTagList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取标签列表失败:', error)
        this.$message.error('获取标签列表失败')
        this.tagList = []
        this.displayTagList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    // 更新显示数据（处理分页和排序）
    updateDisplayData() {
      // 先排序
      this.sortTagListData()
      
      // 再分页
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.displayTagList = this.tagList.slice(start, end)
    },
    
    // 排序标签列表数据
    sortTagListData() {
      const prop = this.sortProp
      const order = this.sortOrder
      
      if (!prop || !order) return
      
      this.tagList.sort((a, b) => {
        let result = 0
        
        if (prop === 'pending_questions') {
          // 先按未订正题目数排序
          result = a.pending_questions - b.pending_questions
          // 如果未订正题目数相同，则按题目总数排序
          if (result === 0) {
            result = a.question_nums - b.question_nums
          }
        } else if (typeof a[prop] === 'number') {
          result = a[prop] - b[prop]
        } else {
          result = String(a[prop]).localeCompare(String(b[prop]))
        }
        
        return order === 'ascending' ? result : -result
      })
    },
    
    // 获取标签关联的题目列表
    async fetchQuestionList(tagCode) {
      this.questionLoading = true
      try {
        const response = await getTagQuestions(tagCode, {
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time
        })
        
        console.log('使用getTagQuestions API返回的数据:', response)
        
        // 确保所有字段都正确初始化
        this.allQuestionList = (response.data || []).map(item => ({
          ...item,
          // 确保Boolean字段被正确处理
          is_collect: Boolean(item.is_collect),
          is_pending: Boolean(item.is_pending),
          // 确保数字字段被正确处理
          question_score: Number(item.question_score) || 0,
          question_score_fix: Number(item.question_score_fix) || 0
        }))
        
        this.questionTotal = this.allQuestionList.length
        this.updateQuestionDisplayData()
      } catch (error) {
        console.error('获取题目列表失败:', error)
        this.$message.error('获取题目列表失败')
        this.allQuestionList = []
        this.questionList = []
        this.questionTotal = 0
      } finally {
        this.questionLoading = false
      }
    },
    
    // 更新题目显示数据（处理分页和排序）
    updateQuestionDisplayData() {
      // 先排序
      this.sortQuestionListData()
      
      // 再分页
      const start = (this.questionCurrentPage - 1) * this.questionPageSize
      const end = start + this.questionPageSize
      this.questionList = this.allQuestionList.slice(start, end)
    },
    
    // 排序题目列表数据
    sortQuestionListData() {
      const prop = this.questionSortProp
      const order = this.questionSortOrder
      
      if (!prop || !order) return
      
      this.allQuestionList.sort((a, b) => {
        let result = 0
        
        if (prop === 'question_level') {
          // 难度等级排序规则
          const levelOrder = {
            '未定义': 0,
            '红题': 1,
            '橙题': 2,
            '黄题': 3,
            '绿题': 4,
            '蓝题': 5,
            '紫题': 6,
            '黑题': 7
          }
          const levelA = a[prop] || '未定义'
          const levelB = b[prop] || '未定义'
          result = levelOrder[levelA] - levelOrder[levelB]
        } else if (typeof a[prop] === 'number') {
          result = a[prop] - b[prop]
        } else {
          result = String(a[prop]).localeCompare(String(b[prop]))
        }
        
        return order === 'ascending' ? result : -result
      })
    },
    
    // 处理日期变化
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0]
        this.searchForm.end_time = val[1]
      } else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
    },
    
    // 处理搜索
    handleSearch() {
      this.currentPage = 1
      // 执行查询时，如果之前是显示全部标签，则恢复只显示有关联题目的标签
      if (this.showAllTags) {
        this.showAllTags = false
      }
      this.fetchTagList()
    },
    
    // 处理重置
    handleReset() {
      // 重置搜索条件
      this.searchForm = {
        tag_name: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      
      // 重置页码
      this.currentPage = 1
      
      // 重置排序状态到默认值
      this.sortProp = 'pending_questions'
      this.sortOrder = 'descending'
      
      // 重置时，如果之前是显示全部标签，则恢复只显示有关联题目的标签
      if (this.showAllTags) {
        this.showAllTags = false
      }
      
      // 重新获取数据
      this.fetchTagList()
    },
    
    // 处理全部标签
    async handleAllTags() {
      // 切换显示全部标签的状态
      this.showAllTags = !this.showAllTags
      
      // 重置搜索条件
      this.searchForm = {
        tag_name: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      
      // 重新获取数据
      this.loading = true
      try {
        const response = await getTagsStatistics({
          show_all: this.showAllTags // 根据状态决定是否显示全部标签
        })
        
        if (response && response.code === 200 && response.data) {
          // 显示标签数据
          this.tagList = response.data || []
          this.total = this.tagList.length
          
          // 应用排序
          this.sortTagListData()
          
          // 重置到第一页
          this.currentPage = 1
          
          // 更新显示数据（使用现有的分页设置）
          this.updateDisplayData()
        } else {
          this.tagList = []
          this.displayTagList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取标签数据失败:', error)
        this.$message.error('获取标签数据失败')
        this.tagList = []
        this.displayTagList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    // 处理展开
    handleExpand(row) {
      // 无论当前状态如何，都展开抽屉
      this.expandedTag = row.tag_code;
      this.currentTag = row;
      this.fetchQuestionList(row.tag_code);
      this.drawerVisible = true;
    },
    
    // 处理抽屉关闭
    handleDrawerClose() {
      this.drawerVisible = false;
      // 不再重置expandedTag，只关闭抽屉
    },
    
    // 处理排序变化
    handleSortChange({ prop, order }) {
      if (!order) {
        // 取消排序时，恢复默认排序
        this.sortProp = 'pending_questions'
        this.sortOrder = 'descending'
      } else {
        this.sortProp = prop
        this.sortOrder = order
      }
      
      this.updateDisplayData()
    },
    
    // 处理题目排序变化
    handleQuestionSortChange({ prop, order }) {
      this.questionSortProp = prop
      this.questionSortOrder = order
      this.updateQuestionDisplayData()
    },
    
    // 处理题目页码变化
    handleQuestionCurrentChange(val) {
      this.questionCurrentPage = val
      this.updateQuestionDisplayData()
    },
    
    // 处理题目每页条数变化
    handleQuestionSizeChange(val) {
      this.questionPageSize = val
      this.questionCurrentPage = 1
      this.updateQuestionDisplayData()
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.updateDisplayData()
    },
    
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.updateDisplayData()
    },
    
    // 获取难度类型
    getDifficultyType(level) {
      const typeMap = {
        '红题': 'danger',
        '橙题': 'warning',
        '黄题': '',
        '绿题': 'success',
        '蓝题': 'info',
        '紫题': '',
        '黑题': 'info'
      }
      return typeMap[level] || ''
    },
    
    // 获取难度颜色（与 Question.vue 保持一致）
    getDifficultyColor(level) {
      const colorMap = {
        '红题': '#F56C6C',  // 红色
        '橙题': '#E6A23C',  // 橙色
        '黄题': '#F7BA2A',  // 黄色
        '绿题': '#67C23A',  // 绿色
        '蓝题': '#409EFF',  // 蓝色
        '紫题': '#8E44AD',  // 紫色
        '黑题': '#2C3E50',  // 黑色
        '': '#909399'       // 灰色
      }
      return colorMap[level] || '#909399'
    },
    
    // 获取难度颜色（根据百分比区间确定）
    getDifficultyColorByPercentage(percentage) {
      if (percentage < 14.29) {
        return '#F56C6C'; // 红题
      } else if (percentage < 28.58) {
        return '#E6A23C'; // 橙题
      } else if (percentage < 42.87) {
        return '#F7BA2A'; // 黄题
      } else if (percentage < 57.15) {
        return '#67C23A'; // 绿题
      } else if (percentage < 71.44) {
        return '#409EFF'; // 蓝题
      } else if (percentage < 85.72) {
        return '#8E44AD'; // 紫题
      } else {
        return '#2C3E50'; // 黑题
      }
    },
    
    // 获取难度级别名称（根据百分比区间确定）
    getDifficultyLevelByPercentage(percentage) {
      if (percentage < 14.29) {
        return '红题难度';
      } else if (percentage < 28.58) {
        return '橙题难度';
      } else if (percentage < 42.87) {
        return '黄题难度';
      } else if (percentage < 57.15) {
        return '绿题难度';
      } else if (percentage < 71.44) {
        return '蓝题难度';
      } else if (percentage < 85.72) {
        return '紫题难度';
      } else {
        return '黑题难度';
      }
    },
    normalizeErrors(errors) {
      if (!errors) return []
      if (Array.isArray(errors)) return errors
      try {
        const arr = JSON.parse(errors)
        return Array.isArray(arr) ? arr : []
      } catch (e) { return [] }
    },
    getErrorOutlineStyle,
    
    // 切换抽屉内错误类型展开状态
    toggleDrawerExpandErrors(questionCode) {
      this.$set(this.expandedDrawerErrors, questionCode, !this.expandedDrawerErrors[questionCode])
    },
    
    // 获取分数颜色
    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266';
      const percentage = (score / 100) * 100;
      if (percentage >= 100) return '#237804'; // 绿色
      if (percentage >= 75) return '#52C41A'; // 黄绿色
      if (percentage >= 50) return '#F7BA2A'; // 黄色
      if (percentage >= 25) return '#E6A23C'; // 橙色
      return '#F56C6C'; // 红色
    },
    
    // 编辑题目
    handleEdit(row) {
      this.currentQuestion = { ...row }
      this.editDialogVisible = true
    },
    
    // 订正题目
    async handleFix(question) {
      try {
        await this.$confirm('确认将该题目订正分数改为100分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        const res = await request({
          url: `/api/game/question/${question.question_code}/fix`,
          method: 'put',
          data: {
            question_score_fix: 100
          }
        })
        
        if (res.code === 200) {
          this.$message.success('订正成功')
          // 更新本地数据
          question.question_score_fix = 100
          
          // 同时更新allQuestionList中对应的数据
          const allIndex = this.allQuestionList.findIndex(item => item.question_code === question.question_code)
          if (allIndex !== -1) {
            this.allQuestionList[allIndex].question_score_fix = 100
          }
          
        } else {
          throw new Error(res.message || '订正失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('订正失败:', error)
          this.$message.error(error.message || '订正失败')
        }
      }
    },
    
    // 收藏/取消收藏
    async handleCollect(row) {
      try {
        await this.$confirm(row.is_collect ? '确认取消收藏该题目吗？' : '确认收藏该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        await updateQuestionCollect(row.question_code, !row.is_collect)
        
        // 更新本地数据 - 直接更新所有相关的数据源
        const newCollectState = !row.is_collect
        
        // 更新allQuestionList中对应的数据
        const allIndex = this.allQuestionList.findIndex(item => item.question_code === row.question_code)
        if (allIndex !== -1) {
          this.$set(this.allQuestionList[allIndex], 'is_collect', newCollectState)
        }
        
        // 更新当前显示的questionList中的数据
        const displayIndex = this.questionList.findIndex(item => item.question_code === row.question_code)
        if (displayIndex !== -1) {
          this.$set(this.questionList[displayIndex], 'is_collect', newCollectState)
        }
        
        // 直接更新传入的row对象
        this.$set(row, 'is_collect', newCollectState)
        
        this.$message.success(newCollectState ? '收藏成功' : '取消收藏成功')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新收藏状态失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    // 挂起/取消挂起
    async handlePending(row) {
      try {
        // 判断题目得分和订正分数
        if (row.question_score === 100 || row.question_score_fix === 100) {
          this.$message.warning('该题目你已经' + (row.question_score === 100 ? 'AC' : '订正') + '，无法挂起。')
          return
        }

        await this.$confirm(row.is_pending ? '确认取消挂起该题目吗？' : '确认挂起该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        await updateQuestionPending(row.question_code, !row.is_pending)
        
        // 更新本地数据 - 直接更新所有相关的数据源
        const newPendingState = !row.is_pending
        
        // 更新allQuestionList中对应的数据
        const allIndex = this.allQuestionList.findIndex(item => item.question_code === row.question_code)
        if (allIndex !== -1) {
          this.$set(this.allQuestionList[allIndex], 'is_pending', newPendingState)
        }
        
        // 更新当前显示的questionList中的数据
        const displayIndex = this.questionList.findIndex(item => item.question_code === row.question_code)
        if (displayIndex !== -1) {
          this.$set(this.questionList[displayIndex], 'is_pending', newPendingState)
        }
        
        // 直接更新传入的row对象
        this.$set(row, 'is_pending', newPendingState)
        
        this.$message.success(newPendingState ? '挂起成功' : '取消挂起成功')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('挂起操作失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    // 编辑成功回调
    handleSuccess() {
      this.editDialogVisible = false
      // 重新获取抽屉中的数据
      this.fetchQuestionList(this.currentTag.tag_code)
    },
    
    // 动态管理弹窗z-index层级，只影响特定弹窗
    setupDialogZIndex() {
      // 监听弹窗显示事件，只调整特定弹窗的z-index
      this.$nextTick(() => {
        // 监听DOM变化，当特定弹窗被添加到body时自动调整层级
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                  // 只处理弹窗容器，不影响抽屉
                  if (node.classList && node.classList.contains('el-dialog__wrapper')) {
                    // 检查是否包含我们的自定义弹窗类
                    const replayDialog = node.querySelector('.tag-replay-dialog')
                    const editDialog = node.querySelector('.tag-edit-dialog')
                    
                    if (replayDialog || editDialog) {
                      node.style.zIndex = '2101'
                    }
                  }
                  
                  // 只处理弹窗相关的遮罩层
                  if (node.classList && node.classList.contains('v-modal')) {
                    // 检查当前是否有我们的弹窗打开
                    if (this.replayDialogVisible || this.editDialogVisible) {
                      node.style.zIndex = '2100'
                    }
                  }
                }
              })
            }
          })
        })
        
        // 开始观察body的子节点变化
        observer.observe(document.body, {
          childList: true,
          subtree: false
        })
        
        // 组件销毁时停止观察
        this.$once('hook:beforeDestroy', () => {
          observer.disconnect()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  
  .filter-card { margin: 8px 0 0 0; flex-shrink: 0; background-color: #fff; position: relative; z-index: 10; height: 72px; 
    :deep(.el-card__body) { height: 100%; padding: 0; } }
  
  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 16px;

    .left-section {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-right: 20px;
      flex-shrink: 1;
      overflow-x: auto;
      height: 100%;
      
      .filter-form {
        display: flex;
        align-items: center;
        white-space: nowrap;
        height: 100%;
        
        .form-content {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 100%;
          
          :deep(.el-input),
          :deep(.el-select) {
            .el-input__inner {
              height: 32px;
              line-height: 32px;
              font-size: 13px;
            }
          }
          
          :deep(.el-button) {
            height: 32px;
            line-height: 30px;
            padding: 0 16px;
            font-size: 13px;
          }
          
          .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
            display: flex;
            align-items: center;
          }

          .filter-buttons {
            margin-left: auto;
            white-space: nowrap;
            
            .el-button + .el-button {
              margin-left: 8px;
            }
          }
        }
      }
    }

    .right-section {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
    }
  }
  
  .table-card { margin: 8px 0 0 0; flex: 1; display: flex; flex-direction: column; overflow: hidden; background-color: #fff; border-radius: 4px; min-height: 0; 
    :deep(.el-card__body) { height: 100%; padding: 0; display: flex; flex-direction: column; min-height: 0; }
    
    :deep(.el-table) { flex: 1; height: 100%;
      .el-table__header-wrapper { position: sticky; top: 0; z-index: 2; background-color: #fff; }
      .el-table__body-wrapper { overflow-y: auto; height: calc(100% - 60px); }
      th { background-color: #f2f3f5; color: #606266; font-weight: 600; font-size: 14px; height: 52px; padding: 0; border-bottom: 1px solid #ebeef5; }
      td { padding: 8px 0; border-bottom: 1px solid #ebeef5; }
      .el-table__row { height: 52px; }
    }}
  
  .pagination-container { height: 40px; padding: 0 16px; background-color: #fff; border-top: 1px solid #e4e7ed; display: flex; justify-content: flex-end; align-items: center; flex-shrink: 0; }
  
  .copyright-card { margin: 8px 0; flex-shrink: 0; background-color: #fff; border-radius: 4px; height: 40px; position: relative; z-index: 1; 
    :deep(.el-card__body) { height: 100%; padding: 0; } 
    .copyright-content { height: 100%; display: flex; align-items: center; justify-content: center; color: #909399; font-size: 14px; } }
  
  .drawer-container { padding: 20px; height: 100%; display: flex; flex-direction: column; overflow: hidden; 
    .drawer-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid #ebeef5; 
      h3 { margin: 0px 0; font-size: 22px; font-weight: 700; color: #303133; }
    }
    
    :deep(.el-table) { flex: 1 1 auto; display: flex; flex-direction: column; overflow: hidden; 
      .el-table__header-wrapper { position: sticky; top: 0; z-index: 2; background-color: #fff; }
      .el-table__body-wrapper { overflow-y: auto; flex: 1; padding-bottom: 12px; }
      th { background-color: #f2f3f5; color: #606266; font-weight: 600; font-size: 14px; height: 52px; padding: 0; border-bottom: 1px solid #ebeef5; }
      td { padding: 8px 0; border-bottom: 1px solid #ebeef5; }
      .el-table__row { height: 52px; }
    }

    .drawer-pagination-container { height: 48px; padding: 10px 16px 0; background-color: #fff; display: flex; justify-content: flex-end; align-items: center; flex-shrink: 0; margin-top: 5px; border-top: 1px solid #e4e7ed; }
  }
  
  a {
    color: #409EFF;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .progress-cell {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 8px;
    transition: all 0.3s;
    
    .progress-value {
      margin-bottom: 8px;
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      text-align: right;
    }
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.02);
      border-radius: 4px;
    }
  }
  
  ::v-deep .el-progress {      
    .el-progress-bar__outer {
      background-color: #f0f2f5;
      border-radius: 4px;
    }
    
    .el-progress-bar__inner {
      border-radius: 4px;
      transition: width 0.6s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  }
  
  .score-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .el-icon-medal-1 {
      color: #006400; // 深绿色
      font-size: 16px;
    }
  }
  
  .score-perfect {
    color: #006400; // 深绿色
    font-weight: 600;
  }
  
  .score-warning {
    color: #F56C6C;
    font-weight: 500;
  }

  // 题目名称前的复盘图标样式
  .replay-icon {
    color: #F56C6C;
    cursor: pointer;
    margin-right: 2px;
    transition: opacity 0.2s ease;
    
    &:hover {
      opacity: 0.8;
    }
  }
  
  // 复盘弹窗距离顶部
  ::v-deep .replay-dialog {
    margin-top: 10vh !important;
  }
}

/* 标签抽屉样式 */
::v-deep .el-drawer__wrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 2001 !important;
}

::v-deep .tag-drawer {
  background-color: #fff !important;
  
  .el-drawer__header {
    background-color: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
    color: inherit !important;
  }
  
  .el-drawer__body {
    background-color: #fff !important;
    padding: 0 !important;
  }
}

/* 全局样式 - 难度提示框 */
.difficulty-tooltip {
  max-width: 600px !important;
  padding: 0 !important;
  border-radius: 6px !important;
}

.difficulty-tooltip-content {
  max-height: none;
  overflow-y: visible;
  padding: 0;
}

.difficulty-description {
  line-height: 1.6;
  font-size: 13px;
}

.difficulty-description p {
  margin: 8px 0;
  color: #ffffff;
}

.difficulty-description p strong {
  color: #409EFF;
  font-weight: 600;
}

.difficulty-description ul {
  margin: 4px 0 8px 0;
  padding-left: 16px;
}

.difficulty-description li {
  margin: 2px 0;
  color: #e6e6e6;
  font-size: 12px;
}

.difficulty-levels {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.difficulty-level {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 13px;
}

.level-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 8px;
}

.level-range {
  width: 130px;
  display: inline-block;
  font-weight: bold;
}

.level-name {
  flex: 1;
}

/* 操作按钮样式（与 Wrongbook.vue 保持一致） */
.operation-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  
  .operation-button {
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 4px;
    margin: 0;
    border: none;
    transition: all 0.2s ease;
    
    i {
      font-size: 14px;
      color: white;
    }
    
    // 编辑按钮 - 深蓝色
    &.edit-button {
      background-color: #0056b3;
      
      &:hover {
        background-color: #004494;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #003d82;
      }
    }
    
    // 订正按钮 - 绿色
    &.fix-button {
      background-color: #67C23A;
      
      &:hover {
        background-color: #5daf34;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #529b2e;
      }
    }
    
    // 复盘按钮 - 紫色
    &.replay-button {
      background-color: #6f42c1;
      
      &:hover {
        background-color: #5f3a9f;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #4e2a84;
      }
    }
    
    // 收藏按钮（未收藏状态）- 蓝色
    &.collect-button {
      background-color: #409EFF;
      
      &:hover {
        background-color: #337ecc;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #2b6cb0;
      }
    }
    
    // 收藏按钮（已收藏状态）- 黄色
    &.collect-active-button {
      background-color: #F7BA2A;
      
      &:hover {
        background-color: #e6a723;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #d4951c;
      }
    }
    
    // 挂起按钮（未挂起状态）- 蓝色
    &.pending-button {
      background-color: #409EFF;
      
      &:hover {
        background-color: #337ecc;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #2b6cb0;
      }
    }
    
    // 挂起按钮（已挂起状态）- 橙色
    &.pending-active-button {
      background-color: #E6A23C;
      
      &:hover {
        background-color: #d49134;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #c08025;
      }
    }
    
    // 禁用状态按钮
    &.disabled-button {
      background-color: #F2F3F5;
      cursor: not-allowed;
      opacity: 0.6;
      
      i {
        color: #C0C4CC;
      }
      
      &:hover {
        background-color: #F2F3F5;
        transform: none;
        box-shadow: none;
      }
    }
    
    &:disabled {
      cursor: not-allowed;
      background-color: #F2F3F5;
      opacity: 0.6;
      
      i {
        color: #C0C4CC;
      }
      
      &:hover {
        transform: none;
        box-shadow: none;
      }
    }
  }
}

/* 操作列背景样式 */
::v-deep .operation-column .cell {
  background-color: rgba(248, 249, 250, 0.6) !important;
  padding: 8px 4px !important;
}

/* 错误类型列样式 */
::v-deep .error-type-column .cell {
  background-color: transparent !important;
  padding: 8px 0 8px 12px !important;
  text-align: left !important;
}

/* 移除错误类型列的斑马纹背景 */
::v-deep .el-table__row .error-type-column .cell,
::v-deep .el-table__row.el-table__row--striped .error-type-column .cell {
  background-color: transparent !important;
}

/* 链接样式 */
.name-link {
  color: #409EFF;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
}

/* 文本省略样式 */
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  .link-text {
    color: #409EFF;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

/* 错误类型展开按钮样式 */
.error-expand-btn {
  padding: 2px 8px !important;
  font-size: 12px !important;
  color: #409EFF !important;
  height: 24px !important;
  line-height: 22px !important;
  vertical-align: middle !important;
  
  &:hover {
    background-color: #ecf5ff !important;
    border-radius: 4px !important;
  }
}

/* 错误类型outline标签样式 */
.error-outline-tag {
  background-color: transparent !important;
  vertical-align: middle !important;
}
</style>

<!-- 全局样式：修复弹窗层级问题，但不影响抽屉 -->
<style>
/* 
  层级结构：
  - 页面内容: z-index: 1
  - 抽屉(无遮罩): z-index: 2001
  - 弹窗遮罩: z-index: 2100
  - 弹窗: z-index: 2101
  - 确认框: z-index: 2200
*/

/* 确保抽屉在正确层级，但没有遮罩 */
.tag-drawer {
  z-index: 2001 !important;
}

/* 只提升从抽屉内触发的弹窗的层级 */
.el-dialog.tag-replay-dialog {
  z-index: 2101 !important;
}

.el-dialog.tag-edit-dialog {
  z-index: 2101 !important;
}

/* 确保从抽屉内弹出的dialog wrapper有正确的层级 */
body > .el-dialog__wrapper:has(.tag-replay-dialog),
body > .el-dialog__wrapper:has(.tag-edit-dialog) {
  z-index: 2101 !important;
}

/* 确保确认框在最顶层 */
.el-message-box__wrapper {
  z-index: 2200 !important;
}

/* 确保Message提示也在顶层 */
.el-message {
  z-index: 2300 !important;
}
</style> 